<template>
  <div
    v-if="taxGroup"
  >
    <v-widget
      :title="taxGroup.name"
    >
      <div
        slot="widget-header-action"
      >
        <div slot="widget-header-action">
          <v-switch
            slot="activator"
            v-model="taxGroup.shipping_taxable"
            :label="$t('Shipping is taxable')"
            class="mt-4"
          />
        </div>
      </div>
      <div slot="widget-content">
        <v-form>
          <v-container>
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
              >
                <v-text-field
                  v-model="taxGroup.name"
                  :error-messages="taxGroup.displayErrors('name')"
                  :label="$t('Tax group name')"
                  outline
                />
                <v-autocomplete
                  v-model="taxGroup.zone_code"
                  :items="zones"
                  :error-messages="taxGroup.displayErrors('zone_code')"
                  :label="$t('Locations')"
                  item-text="label"
                  item-value="code"
                  outline
                />
                <v-autocomplete
                  :items="taxRates"
                  v-model="taxGroup.rates"
                  :error-messages="taxGroup.displayErrors('rates')"
                  :label="$t('Select tax rates')"
                  item-text="code"
                  return-object
                  menu-props="{maxHeight:'auto'}"
                  multiple
                  outline
                />
                <v-autocomplete
                  :items="customerGroups"
                  v-model="taxGroup.customer_group"
                  :error-messages="taxGroup.displayErrors('customer_group')"
                  :label="$t('Select customer group')"
                  item-text="name"
                  item-value="code"
                  menu-props="{maxHeight:'auto'}"
                  outline
                />
                <v-layout
                  row
                  wrap
                  class="align-center"
                >
                  <v-flex
                    xs10
                    sm11
                    @click="dialog = true"
                  >
                    <v-select
                      :items="taxonomy"
                      v-model="taxGroup.taxonomy"
                      :error-messages="taxGroup.displayErrors('taxonomy')"
                      :label="$t('Taxonomy')"
                      readonly
                      item-text="name"
                      item-value="code"
                      menu-props="{maxHeight:'auto'}"
                      outline
                    />
                  </v-flex>
                  <v-tooltip
                    class="taxonomy-tooltip"
                    left
                  >
                    <v-icon
                      slot="activator"
                      color="primary"
                    >
                      info
                    </v-icon>
                    <span>{{ $t('Leaving taxonomy field empty will cause tax group to match all products.') }}</span>
                  </v-tooltip>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
        <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
        >
          <div>
            <VWidget
              :title="$t('Select Taxonomy')"
            >
              <v-layout
                slot="widget-content"
                row
                wrap
              >
                <v-flex xs12>
                  <v-treeview
                    :items="taxonomyTree"
                    :active.sync="active"
                    activatable
                    hoverable
                    active-class="primary--text"
                    return-object
                  />
                </v-flex>
              </v-layout>
            </VWidget>
            <v-card>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="darken-1"
                  flat
                  small
                  @click="dialog = false"
                >
                  {{ $t('Close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-dialog>
      </div>
    </v-widget>
  </div>
</template>

<script>
import LoadingState from '@/components/LoadingState'

export default {
  name: 'SettingsTaxGroup',

  components: {
    LoadingState
  },

  props: {
    taxGroup: {
      type: Object,
      default: () => {}
    },
    taxRates: {
      type: Array,
      default: () => []
    },
    taxonomy: {
      type: Array,
      default: () => []
    },
    taxonomyTree: {
      type: Array,
      default: () => []
    },
    zones: {
      type: Array,
      default: () => []
    },
    customerGroups: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      active: [],
      dialog: false
    }
  },

  watch: {
    active: {
      handler: function (val) {
        if (val[0]) {
          const taxon = val[0]._attributes || val[0]
          this.taxGroup.taxonomy = taxon.code
        }
      }
    }
  },

  created () {
    this.active = [this.taxGroup.taxonomy]
  }
}
</script>

<style lang="stylus">
  .v-treeview--hoverable {
    .v-treeview-node__root:hover {
      cursor: pointer
    }
  }
  .taxonomy-tooltip {
    top: -12px;
    left: 10px;
    position: relative;
  }
</style>
